import React from "react";
import styles from "./HoverText.module.css";

function HoverText({ children }) {
  return <p className={styles.text}>{children}</p>;
}

export { HoverText };
